export default "/images/catalog-content-banner.png?1cf4d0c53b1045e4bd99440dc086f185";